import { addDoc, collection, deleteDoc, doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "@/lib/firebase";
import type { BudgetItem } from "@amazing-wedding/shared-types";

type NewBudgetItem = Omit<BudgetItem, "id" | "createdAt" | "updatedAt">;
type BudgetItemPatch = Partial<NewBudgetItem>;

export async function addBudgetItem(weddingId: string, input: NewBudgetItem): Promise<string> {
  const ref = await addDoc(collection(db, "weddings", weddingId, "budgetItems"), {
    ...input,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return ref.id;
}

export async function updateBudgetItem(
  weddingId: string,
  id: string,
  patch: BudgetItemPatch,
): Promise<void> {
  await updateDoc(doc(db, "weddings", weddingId, "budgetItems", id), {
    ...patch,
    updatedAt: serverTimestamp(),
  });
}

export async function deleteBudgetItem(weddingId: string, id: string): Promise<void> {
  await deleteDoc(doc(db, "weddings", weddingId, "budgetItems", id));
}
